import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { userRoleInfo } from "@/api/data";
import infoList from "@/mixins/infoList";
export default {
  name: "compRoleInfo",
  props: {
    serverList: Object
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: userRoleInfo,
      searchInfo: {},
      code: 1,
      dataInfo: {},
      is_init: 0,
      roleIdCache: ""
    };
  },
  methods: {
    loadTatleData: function loadTatleData(e) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // this.$router.push({ query: {} });

              _this.searchInfo = e;
              if (!(_this.searchInfo.roleId || _this.searchInfo.roleName)) {
                _context.next = 10;
                break;
              }
              _this.loading = true;
              _context.next = 5;
              return userRoleInfo(_this.searchInfo);
            case 5:
              res = _context.sent;
              if (res.code == 0) {
                _this.dataInfo = res.data;
                _this.is_init = 1;
              } else if (res.code == 7) {
                _this.dataInfo = {};
                _this.is_init = 0;
              }
              _this.loading = false;
              _context.next = 13;
              break;
            case 10:
              _this.dataInfo = {};
              _this.is_init = 0;
              _this.$message({
                message: "请输入条件进行查询"
              });
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    goRouterMsg: function goRouterMsg(e) {
      window.localStorage.setItem("roleId", e);
      this.$router.push({
        name: "userRoleInfo",
        query: {
          roleId: e,
          //new Date().getTime()
          time: new Date().getTime()
        }
      });
    }
  }
};